import Cookies from 'js-cookie';
import './htjssdk';
import {getPlatform} from './platform';
import {getProjectInfo as getAppProjectInfo} from './app/api';

export default function (){
    let userId = Cookies.get('userId') ? Cookies.get('userId') : 0;
    if (getPlatform() === 'APP') {
        userId = getAppProjectInfo().user_id;
    }
    ht.login(userId);
    ht.init({
        user: {
            userId: parseInt(userId, 10)
        },
        project: {
            project: 's3',
            version: 'v0.0.1',
            experimentId: '1'
        }
    });
}
